import { gql } from "@apollo/client";

export default gql`
  mutation markPreviousMeetingTopicsAsDiscussedMutation($meetingId: Int!) {
    markPreviousMeetingTopicsAsDiscussed(meetingId: $meetingId) {
      meeting {
        id
        undiscussedPreviousMeetingTopics {
          id
          title
        }
      }
    }
  }
`;
